<template>
  <div>
    <div id="chart" ref="main" style="width: 100%; height: 230px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea: null,
      pieCounts: 6,
    };
  },
  props:{
    souceDataName:[],
    souceDataValue:[]
  },
  mounted() {
    this.initChart();
    this.pieInterval(this.pieCounts);
  },
  methods: {
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
      this.updatedChart();
    },
    // 饼图突出显示的定时器
    pieInterval(count) {
      setInterval(() => {
        this.echartArea.dispatchAction({
          type: "downplay",
          seriesIndex: [0, 1],
        });
        this.echartArea.dispatchAction({
          type: "highlight",
          seriesIndex: [0, 1],
          dataIndex: count % 6,
        });
        count++;
      }, 1000);
    },
    updatedChart() {
      var xName = this.souceDataName;
      var yValue = this.souceDataValue
      const option = {
        title: [
          {
            show: true,
            text: "充电时长",
            textStyle: {
              color: "#B3CCFF",
              fontSize: 25,
              fontWeight: "bold",
            },
            left: "49%",
            top: "50%",
          },
          {
            show: true,
            text: "近7日订单",
            textStyle: {
              color: "#00ECFC",
              fontSize: 18,
            },
            left: "51%",
            top: "37%",
          },
        ],
        legend: {
          orient: "vertical",
          left: "0",
          top: "30%",
          height: 300,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "15%",
          right: "0%",
          bottom: "2%",
          top: "5%",
          containLabel: true,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            hoverAnimation: false,
            legendHoverLink: false,
            radius: ["55%", "65%"],
            left: "22%",
            top: "0",
            color: [
              "#915872",
              "#3077b7",
              "#9a8169",
              "#3f8797",
              "#5b8144",
              "#307889",
            ],
            label: {
              show: false,
              normal: {
                position: "inner",
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            tooltip: {
              show: true,
            },

            // data: [
            //   { value: 435, name: "" },
            //   { value: 679, name: "" },
            //   { value: 848, name: "" },
            //   { value: 348, name: "" },
            //   { value: 679, name: "" },
            //   { value: 848, name: "" },
            // ],
            data:yValue
          },
          {
            name: "访问来源",
            type: "pie",
            radius: ["65%", "92%"],
            // radius: ["42%", "55%"],
            left: "22%",
            top: "0",
            color: [
              "#d74e67",
              "#0092ff",
              "#eba954",
              "#21b6b9",
              "#60a900",
              "#01949b",
            ],
            label: {
              show: false,
              // normal: {
              //   formatter: "{b}\n{d}%",
              // },
            },
            // data: [
            //   { value: 435, name: "2D线" },
            //   { value: 679, name: "3D线" },
            //   { value: 848, name: "资源类" },
            //   { value: 348, name: "采集类" },
            //   { value: 679, name: "宝宝大全" },
            //   { value: 848, name: "2D视频" },
            // ],
            data:xName
          },
        ],
      };
      this.echartArea.setOption(option);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/bicycle-system/pie-center/left-pie.vue